document.addEventListener("DOMContentLoaded", function () {

  console.log('Script geladen, aktueller Pfad:', window.location.pathname);

  // Prüfe ob wir auf der Account-Seite sind
  if (!window.location.pathname.includes('/account')) {
    console.log('Nicht auf Account-Seite, custom-products wird nicht geladen. Pfad:', window.location.pathname);
    return;
  }
  
  console.log('Auf Account-Seite, starte custom-products');

  // Konfiguration
  const N8N_WEBHOOK_URL = 'https://n8n.srv915020.hstgr.cloud/webhook/fb72587f-f9f8-482e-b776-0ae3668041fb'; // Webhook für Produktdaten
  const N8N_CREATE_PRODUCT_WEBHOOK_URL = 'https://n8n.srv915020.hstgr.cloud/webhook/cdb709d1-8154-4def-ab59-9cfd882ebc3d'; // Webhook für Produkt-Erstellung
  const CUSTOMER_METAFIELD_KEY = 'B2B_RF_ID_29049.text-field-a5dcbba57ccfe';
  
  // Kundennummer aus Shopify Customer Metafield abrufen
  async function getCustomerNumber() {
    try {
      // Shopify Customer ID aus window.meta (falls verfügbar)
      const customerId = window.meta?.page?.customerId;
      
      if (!customerId) {
        console.error('Customer ID nicht gefunden');
        return null;
      }
      
      console.log('Customer ID:', customerId);
      
      // Kundennummer aus Metafield abrufen
      // Da wir im Frontend sind, können wir das Metafield nicht direkt über die Storefront API abfragen
      // Wir müssen es über das Liquid-Template übergeben oder über einen Webhook abrufen
      
      // Option 1: Über Liquid-Template (empfohlen)
      // Das Metafield sollte im Template als data-Attribut übergeben werden
      const customerNumberElement = document.querySelector('[data-customer-number]');
      console.log('Suche nach [data-customer-number] Element:', customerNumberElement);
      
      if (customerNumberElement) {
        let number = customerNumberElement.dataset.customerNumber;
        console.log('Kundennummer aus data-Attribut (roh):', number);
        
        // Bereinige die Nummer: Entferne HTML-Tags und Whitespace
        if (number) {
          number = number.replace(/<[^>]*>/g, '').trim(); // Entferne HTML-Tags
          number = number.split('\n')[0].trim(); // Nimm nur die erste Zeile
          console.log('Kundennummer bereinigt:', number);
          
          if (number !== '') {
            return number;
          }
        }
      }
      
      // Option 2: Prüfe auch das #custom-products Element selbst
      const customProductsEl = document.getElementById('custom-products');
      if (customProductsEl && customProductsEl.dataset.customerNumber) {
        let number = customProductsEl.dataset.customerNumber;
        console.log('Kundennummer aus #custom-products Element (roh):', number);
        
        // Bereinige die Nummer: Entferne HTML-Tags und Whitespace
        if (number) {
          number = number.replace(/<[^>]*>/g, '').trim(); // Entferne HTML-Tags
          number = number.split('\n')[0].trim(); // Nimm nur die erste Zeile
          console.log('Kundennummer bereinigt:', number);
          
          if (number !== '') {
            return number;
          }
        }
      }
      
      // Option 3: Über n8n Webhook abrufen
      // Dieser Ansatz erfordert einen separaten Webhook
      console.warn('Kundennummer nicht als data-Attribut gefunden');
      return null;
      
    } catch (error) {
      console.error('Fehler beim Abrufen der Kundennummer:', error);
      return null;
    }
  }
  
  // Produktdaten von n8n Webhook abrufen
  async function fetchProductsFromWebhook(customerNumber) {
    if (!N8N_WEBHOOK_URL || N8N_WEBHOOK_URL === 'YOUR_N8N_WEBHOOK_URL_HERE') {
      console.error('n8n Webhook URL nicht konfiguriert');
      return null;
    }
    
    try {
      console.log('Rufe Produktdaten für Kundennummer ab:', customerNumber);
      
      const response = await fetch(N8N_WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customerNumber: customerNumber,
          shopDomain: window.Shopify?.shop || ''
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Produktdaten erhalten:', data);
      
      // Erwartetes Format: { success: true, products: [...] }
      if (data.success && Array.isArray(data.products)) {
        return data.products;
      }
      
      throw new Error(data.error || 'Keine Produktdaten erhalten');
      
    } catch (error) {
      console.error('Fehler beim Abrufen der Produktdaten:', error);
      return null;
    }
  }

  // Dummy-Daten für die Tabelle (Phase 1 - Fallback)
  const dummyProducts = [
    {
      artikelNr: "12345",
      beschreibung: "Dummy Artikelbeschreibung",
      vpe: "1",
      menge: 1,
      preis: "1,00"
    }
  ];

  // Tabelle mit Styling erstellen
  function createProductTable(products) {
    // Falls keine Produkte übergeben wurden, verwende Dummy-Daten
    if (!products || products.length === 0) {
      products = dummyProducts;
    }
    // Container erstellen
    const container = document.createElement('div');
    container.className = 'container bss-b2b-quick-order-list';
    container.style.maxWidth = '1340px';
    container.style.margin = '0 auto';
    
    // Tabelle erstellen mit ID für DataTables
    const table = document.createElement('table');
    table.id = 'custom-products-table';
    table.className = 'display'; // 'nowrap' entfernt, damit Text umbrochen werden kann
    table.style.width = '100%';
    
    // Thead erstellen
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');
    
    const headers = ['Artikel-Nr.', 'Artikelbeschreibung', 'VPE', 'Menge', 'Preis', ''];
    headers.forEach(headerText => {
      const th = document.createElement('th');
      th.textContent = headerText;
      if (headerText !== 'Artikel-Nr.' && headerText !== 'Artikelbeschreibung') {
        th.className = 'no-controlls';
      }
      if (headerText === 'VPE') {
        th.className += ' thousands';
      }
      headerRow.appendChild(th);
    });
    
    thead.appendChild(headerRow);
    table.appendChild(thead);
    
    // Tbody mit Produktdaten erstellen
    const tbody = document.createElement('tbody');
    
    products.forEach((product, index) => {
      const row = document.createElement('tr');
      
      // Artikel-Nr.
      const tdArtikelNr = document.createElement('td');
      tdArtikelNr.textContent = product.artikelNr;
      row.appendChild(tdArtikelNr);
      
      // Beschreibung (mehrzeilig mit max-width)
      const tdBeschreibung = document.createElement('td');
      tdBeschreibung.textContent = product.beschreibung;
      tdBeschreibung.style.maxWidth = '300px';
      tdBeschreibung.style.whiteSpace = 'normal';
      tdBeschreibung.style.wordWrap = 'break-word';
      row.appendChild(tdBeschreibung);
      
      // VPE
      const tdVpe = document.createElement('td');
      tdVpe.className = 'thousands';
      tdVpe.textContent = product.vpe;
      row.appendChild(tdVpe);
      
      // Menge
      const tdMenge = document.createElement('td');
      const inputMenge = document.createElement('input');
      inputMenge.type = 'number';
      inputMenge.id = `quantity-${index + 1}`;
      inputMenge.className = 'quantity-field';
      inputMenge.value = product.menge;
      inputMenge.min = '1';
      inputMenge.style.width = '50px';
      tdMenge.appendChild(inputMenge);
      row.appendChild(tdMenge);
      
      // Preis
      const tdPreis = document.createElement('td');
      tdPreis.className = 'price-column';
      tdPreis.textContent = product.preis + ' €';
      row.appendChild(tdPreis);
      
      // Warenkorb
      const tdWarenkorb = document.createElement('td');
      const btnWarenkorb = document.createElement('button');
      btnWarenkorb.className = 'add-to-cart-btn';
      btnWarenkorb.style.background = 'none';
      btnWarenkorb.style.border = 'none';
      btnWarenkorb.style.cursor = 'pointer';
      
      // Speichere Produktdaten als data-Attribute
      btnWarenkorb.dataset.artikelNr = product.artikelNr;
      btnWarenkorb.dataset.beschreibung = product.beschreibung;
      btnWarenkorb.dataset.preis = product.preis;
      btnWarenkorb.dataset.rowIndex = index;
      
      // Verwende SVG direkt (Warenkorb-Icon)
      btnWarenkorb.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom: -5px;">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="10" y1="11" x2="14" y2="11"></line>
        </svg>
      `;
      btnWarenkorb.title = 'In den Warenkorb';
      
      tdWarenkorb.appendChild(btnWarenkorb);
      row.appendChild(tdWarenkorb);
      
      tbody.appendChild(row);
    });
    
    table.appendChild(tbody);
    container.appendChild(table);
    
    return container;
  }

  // Verhindere mehrfache Ausführungen
  let isProcessing = false;
  let hasProcessed = false;
  
  async function replaceWhenReady() {
    var el = document.getElementById("custom-products");
    if (el) {
      // Verhindere mehrfache Ausführungen
      if (isProcessing || hasProcessed) {
        console.log('Bereits verarbeitet oder in Verarbeitung, überspringe...');
        return true; // Gebe true zurück, damit Observer gestoppt wird
      }
      
      isProcessing = true;
      console.log("custom-products gefunden – Erstelle Produkttabelle");
      
      // Leere das Element und zeige Loading-Indikator
      el.innerHTML = '<p>Lade Produktdaten...</p>';
      
      try {
        // Kundennummer abrufen
        console.log('Starte Kundennummer-Abfrage...');
        const customerNumber = await getCustomerNumber();
        console.log('Kundennummer erhalten:', customerNumber);
        
        // Produktdaten abrufen (falls Kundennummer vorhanden)
        let products = dummyProducts; // Fallback auf Dummy-Daten
        
        if (customerNumber) {
          console.log('Kundennummer vorhanden, rufe Webhook auf...');
          const fetchedProducts = await fetchProductsFromWebhook(customerNumber);
          if (fetchedProducts && fetchedProducts.length > 0) {
            products = fetchedProducts;
            console.log('Verwende Produktdaten vom Webhook:', products.length, 'Produkte');
          } else {
            console.warn('Keine Produktdaten vom Webhook, verwende Dummy-Daten');
          }
        } else {
          console.warn('Keine Kundennummer gefunden, verwende Dummy-Daten');
        }
        
        // Leere das Element erneut
        el.innerHTML = '';
        
        // Erstelle und füge Tabelle hinzu
        const table = createProductTable(products);
        el.appendChild(table);
      
      // DataTables initialisieren (warte kurz, damit die Tabelle im DOM ist)
      setTimeout(() => {
        if (typeof jQuery !== 'undefined' && jQuery.fn.DataTable) {
          // Verwende die ID statt das table-Element direkt
          const $table = jQuery('#custom-products-table');
          if ($table.length > 0) {
            $table.DataTable({
              paging: true,
              searching: true,
              ordering: true,
              info: true,
              autoWidth: false,
              columnDefs: [
                { width: '80px', targets: 0 },  // Artikel-Nr.
                { width: '300px', targets: 1 }, // Artikelbeschreibung
                { width: '80px', targets: 2 },  // STK./VPE
                { width: '80px', targets: 3 },  // Menge
                { width: '100px', targets: 4 }, // Preis
                { width: '60px', targets: 5, orderable: false }  // Warenkorb
              ],
              language: {
                url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/de-DE.json'
              }
            });
            console.log('DataTables initialisiert');
            
            // Event-Handler für Warenkorb-Buttons hinzufügen
            initAddToCartButtons();
          } else {
            console.warn('Tabelle nicht im DOM gefunden');
          }
        } else {
          console.warn('jQuery oder DataTables nicht verfügbar');
        }
      }, 100);
        
        hasProcessed = true;
        isProcessing = false;
        return true;
        
      } catch (error) {
        console.error('Fehler beim Erstellen der Produkttabelle:', error);
        el.innerHTML = '<p>Fehler beim Laden der Produktdaten. Bitte laden Sie die Seite neu.</p>';
        isProcessing = false;
        hasProcessed = true;
        return true;
      }
    }
    return false;
  }

  // Erst direkt versuchen (async)
  console.log('Versuche #custom-products Element zu finden...');
  
  (async function() {
    const found = await replaceWhenReady();
    
    if (found) {
      console.log('#custom-products Element gefunden und verarbeitet');
      return;
    }
    
    console.log('#custom-products Element nicht gefunden, starte MutationObserver...');

    // Wenn nicht vorhanden: MutationObserver starten
    var observer = new MutationObserver(async function (mutations) {
      console.log('MutationObserver: DOM-Änderung erkannt, suche erneut...');
      const found = await replaceWhenReady();
      if (found) {
        console.log('#custom-products Element gefunden und verarbeitet (via MutationObserver)');
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    console.log('MutationObserver gestartet');
  })();
  
  // ========== Warenkorb-Funktionalität ==========
  
  // n8n Webhook aufrufen, um Custom Product zu erstellen
  async function createCustomProduct(artikelNr, beschreibung, preis, menge) {
    if (!N8N_CREATE_PRODUCT_WEBHOOK_URL || N8N_CREATE_PRODUCT_WEBHOOK_URL === 'YOUR_CREATE_PRODUCT_WEBHOOK_URL_HERE') {
      throw new Error('n8n Create Product Webhook URL ist nicht konfiguriert');
    }
    
    try {
      console.log('Erstelle Custom Product:', { artikelNr, beschreibung, preis, menge });
      
      const response = await fetch(N8N_CREATE_PRODUCT_WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          artikelNr: artikelNr,
          beschreibung: beschreibung,
          preis: preis,
          menge: menge,
          shopDomain: window.Shopify?.shop || ''
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Custom Product erstellt:', data);
      
      // Erwartetes Format: { success: true, sampleVariantId: "123456" }
      if (data.success && data.sampleVariantId) {
        return data.sampleVariantId;
      }
      
      throw new Error(data.error || 'Keine Varianten-ID erhalten');
      
    } catch (error) {
      console.error('Fehler beim Erstellen des Custom Products:', error);
      throw error;
    }
  }
  
  // Produkt zum Warenkorb hinzufügen (AJAX Cart API)
  async function addToCart(variantId, menge, properties = {}) {
    try {
      const cartAddUrl = '/cart/add.js';
      
      const cartData = {
        id: variantId,
        quantity: menge,
        properties: properties
      };
      
      console.log('Füge Produkt zum Warenkorb hinzu:', cartData);
      
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartData)
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Cart Add Error:', errorText);
        throw new Error(`Fehler beim Hinzufügen zum Warenkorb: ${response.status}`);
      }
      
      const result = await response.json();
      console.log('Zum Warenkorb hinzugefügt:', result);
      
      return { success: true, cart: result };
      
    } catch (error) {
      console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
      return { success: false, error: error.message };
    }
  }
  
  // Toast-Notification anzeigen
  function showToast(message, isError = false) {
    // Entferne vorhandene Toasts
    const existingToasts = document.querySelectorAll('.toast-notification');
    existingToasts.forEach(toast => toast.remove());
    
    // Erstelle neuen Toast
    const toast = document.createElement('div');
    toast.className = 'toast-notification' + (isError ? ' error' : '');
    toast.textContent = message;
    toast.style.position = 'fixed';
    toast.style.top = '20px';
    toast.style.right = '20px';
    toast.style.backgroundColor = isError ? '#f44336' : '#4caf50';
    toast.style.color = 'white';
    toast.style.padding = '16px 24px';
    toast.style.borderRadius = '4px';
    toast.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
    toast.style.zIndex = '10000';
    toast.style.maxWidth = '300px';
    toast.style.fontSize = '14px';
    
    // Füge Toast zum Body hinzu
    document.body.appendChild(toast);
    
    // Entferne Toast nach 3 Sekunden
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }
  
  // Event-Handler für Warenkorb-Buttons
  function initAddToCartButtons() {
    const cartButtons = document.querySelectorAll('.add-to-cart-btn');
    
    cartButtons.forEach(button => {
      // Verhindere mehrfache Event-Listener
      if (button.dataset.listenerAttached) {
        return;
      }
      button.dataset.listenerAttached = 'true';
      
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Loading-State
        const originalContent = button.innerHTML;
        button.style.opacity = '0.5';
        button.style.pointerEvents = 'none';
        button.innerHTML = '<span>...</span>';
        
        try {
          // Produktdaten aus data-Attributen
          const artikelNr = button.dataset.artikelNr;
          const beschreibung = button.dataset.beschreibung;
          const preis = button.dataset.preis;
          const rowIndex = button.dataset.rowIndex;
          
          // Menge aus Eingabefeld
          const quantityInput = document.getElementById(`quantity-${parseInt(rowIndex) + 1}`);
          const menge = quantityInput ? parseInt(quantityInput.value) : 1;
          
          console.log('Warenkorb-Button geklickt:', { artikelNr, beschreibung, preis, menge });
          
          // 1. Custom Product über n8n erstellen
          const variantId = await createCustomProduct(artikelNr, beschreibung, preis, menge);
          
          // 2. Zum Warenkorb hinzufügen
          const result = await addToCart(variantId, menge, {
            '_custom_product': 'true',
            '_artikel_nr': artikelNr
          });
          
          // Loading-State zurücksetzen
          button.style.opacity = '1';
          button.style.pointerEvents = 'auto';
          button.innerHTML = originalContent;
          
          // Feedback anzeigen
          if (result.success) {
            showToast(`${menge}x ${artikelNr} zum Warenkorb hinzugefügt.`);
            
            // Warenkorb aktualisieren
            if (typeof window.dispatchEvent !== 'undefined') {
              window.dispatchEvent(new CustomEvent('cart:updated'));
            }
          } else {
            showToast(result.error || 'Fehler beim Hinzufügen zum Warenkorb.', true);
          }
          
        } catch (error) {
          console.error('Fehler:', error);
          
          // Loading-State zurücksetzen
          button.style.opacity = '1';
          button.style.pointerEvents = 'auto';
          button.innerHTML = originalContent;
          
          showToast(error.message || 'Fehler beim Hinzufügen zum Warenkorb.', true);
        }
      });
    });
  }

});
